import * as React from 'react';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { Translate } from '../../../../../../../shared/LanguageService';

const HeaderContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    backgroundColor: theme.palette.primary.main,
    borderRadiusTopLeft: '1px',
    borderRadiusTopRight: '1px',
    padding: '8px'
})) as typeof Box;

const HeaderTitle = styled(Typography)(({ theme }) => ({
    fontSize: '14px',
    color: theme.palette.primary.contrastText
}));

const ImageCountChip = styled(Chip)({
    backgroundColor: '#919191'
});

type ImagesSectionHeaderProps = {
    imageCount: number;
};

export function ImagesSectionHeader({ imageCount }: ImagesSectionHeaderProps) {
    return (
        <HeaderContainer component="header">
            <HeaderTitle variant="h2">
                {Translate('image-processing/page/tab/edited-images')}
            </HeaderTitle>
            <ImageCountChip
                label={imageCount}
                color="primary"
                size="small"
            />
        </HeaderContainer>
    );
}
